<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：门店-订单核销记录
      -->
  <div class="user">

    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="所属门店">
          <el-select v-model="formInline.store_id" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item,index) in storeList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核销员姓名">
          <el-input v-model="formInline.search" placeholder="请输入核销员姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchExport">批量导出</el-button>
        </div>
    </div>


    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="store_id" label="ID"></el-table-column>
          <el-table-column prop="store.store_name" label="核销门店">
            <template slot-scope="scope">
              <span class="fb orange">{{scope.row.store.store_name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="clerk.real_name" label="核销员"></el-table-column>
          <el-table-column prop="order.order_no" label="订单号"></el-table-column>
          <el-table-column prop="order_type.text" label="订单类型"></el-table-column>
          <el-table-column prop="create_time" label="核销时间"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
        :page-sizes="[20, 100,500, 1000]"
       layout="total,sizes, prev, pager, next, jumper "
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import StoreApi from '@/api/store.js';
  import qs from 'qs';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*所属门店数据*/
        storeList: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          store_id: '',
          search: ''
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
          /*选中的*/
        multipleSelection: [],
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },
   /*选择数据*/
   handleSelectionChange(e) {
      this.multipleSelection = e;
    },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
         self.loading = true;
        StoreApi.orderList(Params, true)
          .then(data => {
            self.loading = false;
            console.log("data.data.shop_list.data",data.data)
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
            self.storeList = data.data.store_list.data
          
          })
          .catch(error => {
            self.loading = false;
          });
      },
      batchExport(){//批量导出
        // 勾选需要导出的数据
        let ids = [];
      let params = this.multipleSelection;
      console.log("params",params)
      params.forEach((param)=>{
        ids.push(param.store_id);
      })
      ids = ids.join(',');
      // 筛选条件
      // 商品状态
      var parmasa =  this.searchForm?this.searchForm:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      if(ids.length > 0){
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportHexiao?' + 
        qs.stringify(parmasa)+'&ids='+ids;
        
      }else{
        this.$message({
            message: '请选择要导出的数据',
            type: 'error'
          });
      }
   

    },
      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/store/order/index.vue